import { render, staticRenderFns } from "./VerticalView.vue?vue&type=template&id=44a12fbc&scoped=true&"
import script from "./VerticalView.vue?vue&type=script&lang=js&"
export * from "./VerticalView.vue?vue&type=script&lang=js&"
import style0 from "./VerticalView.vue?vue&type=style&index=0&id=44a12fbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a12fbc",
  null
  
)

export default component.exports